import { createSlice } from '@reduxjs/toolkit';
import type { AsyncStatus } from '@/shared/types/asyncState';
import type { NegociacaoGlobal } from '../../types/operacoes';
import type { NegociacoesGlobaisStats } from './services';
import {
  fetchNegociacoesGlobais,
  fetchNegociacoesGlobaisStats,
  fetchNegociacaoGlobalById,
} from './actions';

interface NegociacoesGlobaisState {
  items: NegociacaoGlobal[];
  current: NegociacaoGlobal | null;
  stats: NegociacoesGlobaisStats;
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
  loading: boolean;
  statsLoading: boolean;
  error: string | null;
  status: AsyncStatus;
}

const initialState: NegociacoesGlobaisState = {
  items: [],
  current: null,
  stats: { total: 0, ativas: 0, acordos: 0, falhas: 0, cpfsUnicos: 0 },
  pagination: { page: 1, limit: 20, total: 0, totalPages: 0 },
  loading: false,
  statsLoading: false,
  error: null,
  status: 'idle',
};

const negociacoesGlobaisSlice = createSlice({
  name: 'negociacoesGlobais',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
      state.status = 'idle';
    },
    resetNegociacoesGlobais: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNegociacoesGlobais.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.status = 'loading';
      })
      .addCase(fetchNegociacoesGlobais.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.data;
        state.pagination = action.payload.pagination;
        state.status = 'success';
      })
      .addCase(fetchNegociacoesGlobais.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'Erro desconhecido';
        state.status = 'error';
      })

      .addCase(fetchNegociacoesGlobaisStats.pending, (state) => {
        state.statsLoading = true;
      })
      .addCase(fetchNegociacoesGlobaisStats.fulfilled, (state, action) => {
        state.statsLoading = false;
        state.stats = action.payload;
      })
      .addCase(fetchNegociacoesGlobaisStats.rejected, (state) => {
        state.statsLoading = false;
      })

      .addCase(fetchNegociacaoGlobalById.fulfilled, (state, action) => {
        state.current = action.payload;
      });
  },
});

export const { clearError, resetNegociacoesGlobais } = negociacoesGlobaisSlice.actions;
export const negociacoesGlobaisReducer = negociacoesGlobaisSlice.reducer;
